import React from 'react';
import DefaultSEO from '../components/DefaultSEO';
import AboutSection from '../components/AboutSection';
import WhyChoose from '../components/WhyChoose';
import PopularDestinations from '../components/PopularDestinations';
import SpecialOffers from '../components/SpecialOffers';
import FaqSection from '../components/FaqSection';
import Newsletter from '../components/Newsletter';

const AboutPage = () => {
  return (
    <div className="about-page-wrapper">
      <DefaultSEO
        title="About Us | ZoyoTrip - Redefining Indian Travel & Hospitality"
        description="Learn more about ZoyoTrip, our mission, vision, and commitment to delivering 100% verified stays, transparent pricing, and 24/7 live concierge support across India."
      >
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "AboutPage",
              "name": "About ZoyoTrip",
              "description": "ZoyoTrip is India's smart travel companion delivering verified stays, transparent pricing with no hidden charges, and 24/7 concierge assistance.",
              "url": "https://www.zoyotrip.com/about-us"
            }
          `}
        </script>
      </DefaultSEO>

      {/* 1. Core About Us Experience: Hero, Metrics, Story, Mission/Vision, 4 Quality Pillars */}
      <AboutSection />

      {/* 2. Why Choose ZoyoTrip: 6 Essential Travel Advantages */}
      <WhyChoose />

      {/* 4. Exclusive Special Offers & Seasonal Deals */}
      <SpecialOffers />

      {/* 5. FAQs & 24/7 Concierge Support CTA Banner */}
      <FaqSection />

      {/* 6. Newsletter Subscription */}
      <Newsletter />
    </div>
  );
};

export default AboutPage;